// extracted by mini-css-extract-plugin
module.exports = {"settingsSidebar":"SettingsSidebar_settingsSidebar__S2jd9","wrapper":"SettingsSidebar_wrapper__YVln8","title":"SettingsSidebar_title__3kNvM"};